import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ImageComponent } from '@shared/common';

@Component({
  selector: 'la-content-with-image',
  templateUrl: './content-with-image.component.html',
  styleUrls: ['./content-with-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ImageComponent],
})
export class ContentWithImageComponent {
  @Input() title?: string;
  @Input() header?: string;
  @Input() url?: string;
  @Input() width?: string;
}
